import { render, staticRenderFns } from "./ReportingApi.vue?vue&type=template&id=ebff85d4&"
import script from "./ReportingApi.vue?vue&type=script&lang=js&"
export * from "./ReportingApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReportingApi.vue"
export default component.exports